export const FAQ_ITEMS = [
  {
    question: 'What is Health Grow?',
    answer:
      'Health Grow is a consumer health app for India that combines medication reminders, on-device heart-rate checks, AI-assisted understanding of lab reports, a secure document vault, and emergency mode to notify up to three trusted contacts.',
  },
  {
    question: 'How do I download Health Grow?',
    answer:
      'Visit healthgrow.online and tap Download APK to install the latest Android build. A Google Play listing is coming soon; the website always links to the current release.',
  },
  {
    question: 'Is Health Grow free?',
    answer:
      'Yes. Health Grow is free to download and use. Core features including reminders, vitals tracking, and document storage are available at no cost.',
  },
  {
    question: 'Does Health Grow work offline?',
    answer:
      'Medication reminders and several core features are designed to work when connectivity is limited. AI report analysis and sync features need an internet connection.',
  },
  {
    question: 'Is Health Grow a replacement for a doctor?',
    answer:
      'No. Health Grow helps you stay organized and understand your records—it does not provide medical diagnosis or treatment. Always consult a qualified clinician for medical decisions.',
  },
  {
    question: 'What health data does Health Grow store?',
    answer:
      'Depending on what you use, Health Grow may store profile details, medication schedules, vitals you log, uploaded reports, and emergency contacts. See our Privacy Policy for full details.',
  },
  {
    question: 'How does emergency mode work?',
    answer:
      'You add up to three trusted contacts in the app. In distress, turn on Emergency mode and Health Grow sends them a clear message that you need help.',
  },
  {
    question: 'Who makes Health Grow?',
    answer:
      'Health Grow is built by KP Ventures, a team focused on practical, privacy-conscious health tools for Indian consumers and families.',
  },
];
